import {FieldValues, SubmitHandler, UseFormReturn} from 'react-hook-form';
import clsx from 'clsx';
import React, {ReactNode} from 'react';
import {useStickySentinel} from '@common/utils/hooks/sticky-sentinel';
import {Form} from '@common/ui/forms/form';
import {Button} from '@common/ui/buttons/button';
import {Trans} from '@common/i18n/trans';

interface Props<T extends FieldValues> {
  onSubmit?: SubmitHandler<T>;
  form: UseFormReturn<T>;
  title?: ReactNode;
  subTitle?: ReactNode;
  isLoading?: boolean;
  children: ReactNode;
  actions?: ReactNode;
  backButton?: ReactNode;
  disableSaveWhenNotDirty?: boolean;
  wrapInContainer?: boolean;
  isEnable?: boolean;
}
export function AnalysisRateSheetLayout<T extends FieldValues>({
  onSubmit,
  form,
  title,
  subTitle,
  children,
  actions,
  backButton,
  isLoading = false,
  disableSaveWhenNotDirty = false,
  wrapInContainer = true,
  isEnable= false
}: Props<T>) {
  const {isSticky, sentinelRef} = useStickySentinel();
  const isDirty = !disableSaveWhenNotDirty
    ? true
    : Object.keys(form.formState.dirtyFields).length;

  return (
    <Form
      onSubmit={onSubmit!}
      onBeforeSubmit={() => form.clearErrors()}
      form={form}
    >
      <div ref={sentinelRef} />
      <div
        className={
          wrapInContainer ? ' mx-auto px-24 pb-24' : undefined
        }
      >
      <div className="rounded">{children}</div>
      </div>
      {/* <div className="flex h-40 w-full items-center justify-center">
        <Button
            variant="flat"
            color="primary"
            type="submit"
            disabled={isLoading || !isDirty}
          >
            <Trans message="Save" />
        </Button>
      </div> */}
    </Form>
  );
}
